import type { Configuration } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
        authority: import.meta.env.VITE_AZURE_AUTHORITY,
        redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,
        postLogoutRedirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,
    },
    cache: {
        cacheLocation: 'sessionStorage', // More secure than localStorage
        storeAuthStateInCookie: false, // Not needed for SPAs
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                
                switch (level) {
                    case LogLevel.Error:
                        console.error(`[MSAL] ${message}`);
                        break;
                    case LogLevel.Warning:
                        console.warn(`[MSAL] ${message}`);
                        break;
                    case LogLevel.Info:
                        // Uncomment for debugging: console.info(`[MSAL] ${message}`);
                        break;
                    case LogLevel.Verbose:
                        // Uncomment for debugging: console.debug(`[MSAL] ${message}`);
                        break;
                }
            },
            logLevel: LogLevel.Warning,
        },
        // Token refresh configuration for enterprise-grade reliability
        tokenRenewalOffsetSeconds: 300, // Refresh token 5 minutes before expiry (default 300)
        // allowNativeBroker: false, // Disable native broker for web apps
        
        // Iframe and timeout configuration to prevent timeout errors
        loadFrameTimeout: 10000, // Increase iframe load timeout to 10 seconds (default 6000)
        navigateFrameWait: 1000, // Wait time for iframe navigation (default 500)
        windowHashTimeout: 10000, // Increase hash timeout to 10 seconds (default 6000)
        iframeHashTimeout: 10000, // Increase iframe hash timeout to 10 seconds (default 6000)
    }
};

// Login request configuration
export const loginRequest = {
    scopes: ['User.Read', 'User.ReadBasic.All'],
    prompt: 'select_account' as const,
};

// Separate scope configurations to avoid AADSTS70011 errors
export const apiScopes = {
    backend: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID}/.default`],
    graph: ['User.Read', 'User.ReadBasic.All']
};

export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
    graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};